module.exports = __webpack_public_path__ + "media/images/riders/DANNY_HART-1ea53fccf17c8664cedb0e5018e4eb09.png";